import { changes } from "@/lib/changeLogItems";
import LandingLayout from '@/components/LandingLayout';

const getChangeTypeStyles = (type) => {
  switch (type) {
    case 'feature':
      return 'bg-violet-500/10 text-violet-500 dark:bg-violet-500/20 dark:text-violet-400';
    case 'improvement':
      return 'bg-teal-500/10 text-teal-500 dark:bg-teal-500/20 dark:text-teal-400';
    case 'fix':
      return 'bg-red-500/10 text-red-500 dark:bg-red-500/20 dark:text-red-400';
    default:
      return 'bg-muted text-muted-foreground';
  }
};

const Changelog = () => {
  return (
    <LandingLayout>
      <section className="max-w-5xl mx-auto px-4 py-16 bg-background">
        <div className="space-y-16">
          <div className="space-y-4">
            <div className="inline-block">
              <div className="relative py-2">
                <div className="absolute inset-0 blur-3xl opacity-20 bg-gradient-to-r from-violet-600 to-teal-400" />
                <h1 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-violet-600 to-teal-400 text-transparent bg-clip-text relative sm:leading-tight">
                  Changelog
                </h1>
              </div>
            </div>
            <p className="text-base sm:text-lg text-muted-foreground font-mono">
              New updates and improvements to make your workflow effortless
            </p>
          </div>
          
          <div className="relative space-y-16">
            {/* Timeline lines */}
            <div className="absolute inset-0 ml-[7.5rem] mt-5 hidden sm:block">
              {/* Recent version line - gradient from 100% to 50% */}
              <div className="absolute top-0 w-[2px] h-[400px] bg-gradient-to-b from-violet-500 to-violet-500/25" />
              {/* Past versions line - 50% opacity */}
              <div className="absolute top-[400px] bottom-0 w-[2px] bg-violet-500/25" />
            </div>

            {changes.map((change, index) => (
              <div key={change.version} className="relative grid grid-cols-1 sm:grid-cols-[150px_1fr] gap-4 sm:gap-8">
                <div className="relative">
                  <div className="sm:sticky sm:top-4">
                    <div className="flex items-center">
                      <div className="rounded-lg border border-neutral-200 dark:border-neutral-800 px-4 py-1.5 text-sm font-medium font-mono">
                        {change.version}
                      </div>
                      <div className="absolute right-[13px] w-8 h-8 rounded-full bg-violet-500/10 hidden sm:flex items-center justify-center z-10">
                        {index === 0 ? (
                          <div className="w-4 h-4 rounded-full bg-violet-500"></div>
                        ) : (
                          <div className="w-4 h-4 rounded-full bg-black">
                            <div className="w-4 h-4 rounded-full bg-violet-500/50"></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-8">
                  <div>
                    <div className="flex items-center gap-3 mb-3 mt-1">
                      <div className="text-sm font-medium text-muted-foreground/80 font-mono">
                        {new Date(`${change.date}T12:00:00Z`).toLocaleString('en-US', { 
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                          timeZone: 'America/Denver'
                        })}
                      </div>
                    </div>
                    <p className="text-xl font-medium text-foreground mb-6 leading-relaxed">{change.description}</p>
                  </div>
                  
                  <div className="space-y-8">
                    {change.changes.map((subChange, idx) => (
                      <div key={idx} className="space-y-6">
                        {subChange.changeType === 'fix' && (
                          <div className="flex items-center gap-2 mt-3">
                            <span className={`text-xs font-medium uppercase px-2 py-1.5 rounded-md bg-violet-500/10 text-violet-500`}>
                              {subChange.changeTitle}
                            </span>
                          </div>
                        )}
                        
                        <div className="space-y-8">
                          {subChange.changeBullets.map((changeBullet, bulletIdx) => (
                            <div key={bulletIdx} className="space-y-4">
                              <h4 className="text-base font-semibold text-foreground/90">{changeBullet.bulletContent}</h4>
                              {changeBullet.subBullets.length > 0 && (
                                <ul className="space-y-3 pl-4">
                                  {changeBullet.subBullets.map((subBullet, subBulletIdx) => (
                                    <li key={subBulletIdx} className="text-[15px] text-muted-foreground relative">
                                      <span className="absolute -left-4 top-[0.6em] w-1.5 h-1.5 rounded-full bg-muted-foreground/30"></span>
                                      {subBullet}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </LandingLayout>
  );
};

export default Changelog; 